import { useEffect, useState } from "react";
import { getNotifications, getUnreadCount, markAllRead, markNotificationRead } from "./NotificationService";
import { isPushSubscribed, sendTestPush, subscribeToPush, unsubscribeFromPush } from "./PushService";
import "./NotificationsPanel.css";

export default function NotificationsPanel({ open, onClose }) {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [pushEnabled, setPushEnabled] = useState(false);
  const [pushBusy, setPushBusy] = useState(false);
  const [pushError, setPushError] = useState("");

  const load = async () => {
    const [items, count] = await Promise.all([getNotifications(), getUnreadCount()]);
    setNotifications(items);
    setUnreadCount(count);
    setPushEnabled(await isPushSubscribed());
  };

  useEffect(() => { if (open) load(); }, [open]); // eslint-disable-line

  const handleMarkRead = async (id) => { await markNotificationRead(id); load(); };
  const handleMarkAll  = async ()    => { await markAllRead(); load(); };

  const handleTogglePush = async () => {
    setPushBusy(true); setPushError("");
    try {
      if (pushEnabled) {
        await unsubscribeFromPush();
        setPushEnabled(false);
      } else {
        await subscribeToPush();
        setPushEnabled(true);
      }
    } catch (e) {
      setPushError(e.message);
    }
    setPushBusy(false);
  };

  if (!open) return null;

  return (
    <div className="notification-panel">
      <div className="notification-panel-header">
        <div>
          <div className="notification-title">Notifications</div>
          <div className="notification-subtitle">{unreadCount} unread</div>
        </div>
        <div className="notification-actions">
          <button className="notification-btn" type="button" onClick={handleMarkAll}>Mark all read</button>
          <button className="notification-btn ghost" type="button" onClick={onClose}>Close</button>
        </div>
      </div>

      {/* Push notification toggle */}
      <div className="notification-push-row">
        <span className="notification-push-label">
          {pushEnabled ? "📲 Push on" : "🔕 Push off"}
        </span>
        <button
          className={`notification-push-btn ${pushEnabled ? "active" : ""}`}
          onClick={handleTogglePush}
          disabled={pushBusy}
          type="button"
        >
          {pushBusy ? "…" : pushEnabled ? "Disable" : "Enable for this device"}
        </button>
        {pushEnabled && (
          <button className="notification-push-test" type="button" onClick={sendTestPush}>
            Test
          </button>
        )}
      </div>
      {pushError && <div className="notification-push-error">{pushError}</div>}

      <div className="notification-list">
        {notifications.length === 0 && (
          <div className="notification-empty">No notifications yet.</div>
        )}
        {notifications.map((note) => (
          <button
            key={note.id}
            type="button"
            className={`notification-item ${note.readFlag ? "read" : "unread"}`}
            onClick={() => handleMarkRead(note.id)}
          >
            <div className="notification-item-title">{note.title}</div>
            <div className="notification-item-message">{note.message}</div>
            <div className="notification-item-meta">{note.createdAt?.slice(0, 19)?.replace("T", " ")}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
